import { useState } from "react";
import { Navigate, useLocation, useNavigate } from "react-router-dom";
import { Loader2, Lock } from "lucide-react";
import { api, errorText } from "../lib/api";
import { useAuth } from "./AuthContext";
import { LogoMark } from "../components/site/Logo";
import { useSeo } from "../components/site/Seo";

export default function AdminLogin() {
  const { user, setUser } = useAuth();
  const nav = useNavigate();
  const loc = useLocation();
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [error, setError] = useState("");
  const [busy, setBusy] = useState(false);
  useSeo("Admin login", "Business administrator login");

  if (user) return <Navigate to={loc.state?.from || "/admin"} replace />;

  const submit = async (e) => {
    e.preventDefault();
    setBusy(true);
    setError("");
    try {
      const { data } = await api.post("/auth/login", { email, password });
      setUser(data);
      nav(loc.state?.from || "/admin", { replace: true });
    } catch (err) {
      setError(errorText(err, "Login failed"));
    } finally {
      setBusy(false);
    }
  };

  return (
    <main className="flex min-h-screen items-center justify-center bg-[#0A0A0C] px-4">
      <form onSubmit={submit} className="w-full max-w-sm panel p-8" data-testid="admin-login-form">
        <LogoMark className="h-12 w-12" />
        <h1 className="mt-6 text-3xl font-extrabold uppercase">Admin login</h1>
        <p className="mt-1 text-sm text-gray-400">Authorized business administrators only.</p>
        <label htmlFor="admin-email" className="mt-6 block text-sm font-semibold">Email</label>
        <input id="admin-email" type="email" autoComplete="username" required value={email} onChange={(e) => setEmail(e.target.value)} className="tow-input mt-2" data-testid="admin-login-username-input" />
        <label htmlFor="admin-password" className="mt-4 block text-sm font-semibold">Password</label>
        <input id="admin-password" type="password" autoComplete="current-password" required value={password} onChange={(e) => setPassword(e.target.value)} className="tow-input mt-2" data-testid="admin-login-password-input" />
        {error && <p role="alert" className="mt-4 text-sm text-red-400" data-testid="admin-login-error">{error}</p>}
        <button type="submit" disabled={busy} className="btn-yellow mt-6 w-full py-3" data-testid="admin-login-submit-btn">
          {busy ? <Loader2 className="h-5 w-5 animate-spin" /> : <Lock className="h-4 w-4" />} Sign in
        </button>
      </form>
    </main>
  );
}
